import { useEffect, useRef, useState } from "react";
import * as XLSX from "xlsx";
import Navbar from "../components/Navbar";
import { CalendarInput } from "../components/FormComps";
import Pagination , { PagiSearch } from "../components/Pagination";
import { convertToISO, dateInNumbers, getApiSetting, postApiSetting } from "../assets/functions";
import { ToastContainer, toast } from 'react-toastify';
import { NavLink,useNavigate } from "react-router-dom";

export default function Passbook ({setAuth}) {

    const fromDateRef = useRef(null);
    const toDateRef = useRef(null);
     const navigate = useNavigate();

    const [passbookData, setPassbookData] = useState([]);
    const [dataFilter, setDataFilter] = useState([]);
    const [startOffset, setStartOffset] = useState(0);
    const [search, setSearch] = useState('');
    const [tableDataStatus, setTableDataStatus] = useState('');
    const [totalAmount, setTotalAmount] = useState(0);

    const itemsPerPage = 10;
    const searchData = passbookData.filter(item => Object.values(item).join("").toString().toLowerCase().includes(search.toLowerCase()))
    const endOffset = startOffset + itemsPerPage;
    const currentItems = searchData.slice(startOffset, endOffset)
    const pageCount = Math.ceil(searchData.length / itemsPerPage)

    useEffect(()=>{
        setTableDataStatus('Loading...');
        (async()=>{
            try {
                let res = await fetch('/Admin/api/Admin/reportDataPayout', getApiSetting());
                let result = res.status === 200 ? await res.json(): "";
                console.log(res)
                console.log(result)
                if(res.status === 200){
                    if(result.data.length < 1){
                        setTableDataStatus('Not Found')
                    }else{
                        let data = result.data.sort(function(a, b) {
                            let c = new Date(convertToISO(a.requestInitiatedDateTime));
                            let d = new Date(convertToISO(b.requestInitiatedDateTime));
                            return d-c;
                        })
                        setTableDataStatus('')
                        setPassbookData(data)
                        setDataFilter(data)
                    }
                }
                 else if(res.status === 401)
                { 
                    setAuth(false)
                    toast.error("Session Expired !", {position: 'top-center',});
                    navigate("/");                  
                    sessionStorage.clear();
                }
            } catch (error) {
                console.log(error)
            }
        })()
    },[])

    useEffect(()=>{
        if(searchData.length > 0){
          let totalAmt = searchData.map((item)=> parseFloat(item.transhferAmount/100) ).reduce((a,b)=>a+b).toFixed(2);
        //   console.log(totalAmt)
          setTotalAmount(totalAmt)
        }else{
          setTotalAmount(0)
        }
    },[searchData])

    const searchTransactions = async () => {
        let fDate = fromDateRef.current.value;
        let tDate =  toDateRef.current.value;
        if(!fDate || !tDate) {
            alert('Report date are required.')
            return false;
        }
        setTableDataStatus('Loading...')
        setPassbookData([])
        setDataFilter([])
        let postSetting = postApiSetting({fDate,tDate})
        let res = await fetch('/Admin/api/Admin/reportDataByDatePayout', postSetting);
        let result = (res.status === 200) ? await res.json(): "";
        console.log(result)
        // if(res.status !== 200){
        //     alert('something went wrong : '+ res.status)
        // }else
            if(res.status == 200)
            {
            if(result.data.length < 1){
                setTableDataStatus('Not Found');
            }else{
                let data = result.data.sort(function(a, b) {
                    let c = new Date(convertToISO(a.requestInitiatedDateTime));
                    let d = new Date(convertToISO(b.requestInitiatedDateTime));
                    return d-c;
                })
                setTableDataStatus('');
                setPassbookData(data)
                setDataFilter(data)
            }
        }
           else if(res.status === 401)
                { 
                    setAuth(false)
                    toast.error("Session Expired !", {position: 'top-center',});
                    navigate("/");                  
                    sessionStorage.clear();
                }
    }
    const changeHandler = () => {
        let countries = document.querySelectorAll('.fts_filter input');
        let selectedStatuses = [];
        let selectedTxnTypes = [];
        countries.forEach(item => {
            if (item.checked) {
                if ([
                    'Pending For Authorization',
                     'Transaction Successful',
                      'Transaction Failed', 
                      'Transaction Initiated'
                    ].includes(item.value)) {
                    selectedStatuses.push(item.value);
                } else if (['C', 'D'].includes(item.value)) {
                    selectedTxnTypes.push(item.value);
                }
            }
        });
        const filteredArray = dataFilter.filter(item => {
            const matchStatus = selectedStatuses.length > 0 ? selectedStatuses.includes(item.status) : true;
            const matchTxnType = selectedTxnTypes.length > 0 ? selectedTxnTypes.includes(item.txnType) : true;
    
            return matchStatus && matchTxnType; 
        });

    setPassbookData(filteredArray)
        if (filteredArray.length < 1) setTableDataStatus('Not Found')
    }

    const downloadReport = () => {
        // let data = searchData.map((item) => {
        //     return {...item, 
        //         payAmount:(item.payAmount/100).toString(), 
        //         requestAmount:(item.requestAmount/100).toString()
        //     }
        // })
        let date = dateInNumbers();
        let workbook = XLSX.utils.book_new();
        let worksheet = XLSX.utils.json_to_sheet(searchData);
        XLSX.utils.book_append_sheet(workbook, worksheet, "TxnReport");
        XLSX.writeFile(workbook, `TxnReport_${date}.xlsx`);
    }

    return (<>
        {/* <SidebarNavigation /> */}
        <section className="transaction-page">
            <Navbar title="TRANSACTIONS" />
            <div className="container-fluid pe-3">
                <div className="main-content my-3">
                    <h6 className="mb-3">PASSBOOK</h6>
                    <form className="mb-4">
                        <div className="row">
                            <div className="col-sm-2">
                                <CalendarInput dateRef={fromDateRef} />
                            </div>
                            <div className="col-sm-2">
                                <CalendarInput dateRef={toDateRef} />
                            </div>
                            <div className="col-sm-3">
                                <button type="button" className="btn btn-sm _themebg-0 text-white me-3" onClick={searchTransactions}>
                                <i className="fa-solid fa-magnifying-glass"></i> Search</button>
                                <button type="button" className="btn btn-sm _themebg-0 text-white me-3" onClick={downloadReport}>
                                <i className="fa-solid fa-file-arrow-down pe-1"></i>Download</button>
                            </div>
                        </div>
                    </form>

                    <ul className="list-group list-group-horizontal-md mb-3 mt-2 fts_filter">
                        <li className="list-group-item">
                            <div className="form-check">
                                <input className="form-check-input check-bg" type="checkbox" id='txnfltrcheck1' value='Pending For Authorization' onChange={changeHandler} />
                                <label className="form-check-label" htmlFor='txnfltrcheck1'>PENDING</label>
                            </div>
                        </li>
                        <li className="list-group-item">
                        <div className="form-check">
                                <input className="form-check-input check-bg" type="checkbox" id='txnfltrcheck2' value='Transaction Failed' onChange={changeHandler} />
                                <label className="form-check-label" htmlFor='txnfltrcheck2'>FAILED</label>
                            </div>
                        </li>
                        <li className="list-group-item">
                        <div className="form-check">
                                <input className="form-check-input check-bg" type="checkbox" id='txnfltrcheck3' value='Transaction Successful' onChange={changeHandler} />
                                <label className="form-check-label" htmlFor='txnfltrcheck3'>SUCCESS</label>
                            </div>
                        </li>
                        <li className="list-group-item">
                        <div className="form-check">
                                <input className="form-check-input check-bg" type="checkbox" id='txnfltrcheck4' value='Transaction Initiated' onChange={changeHandler} />
                                <label className="form-check-label" htmlFor='txnfltrcheck4'>INITIATED</label>
                            </div>
                        </li>
                        <li className="list-group-item">
                            <div className="form-check">
                                <input className="form-check-input check-bg" type="checkbox" id='txnfltrcheck5' value='C' onChange={changeHandler} />
                                <label className="form-check-label" htmlFor='txnfltrcheck5'>CREDIT</label>
                            </div>
                        </li>
                        <li className="list-group-item">
                            <div className="form-check">
                                <input className="form-check-input check-bg" type="checkbox" id='txnfltrcheck6' value='D' onChange={changeHandler} />
                                <label className="form-check-label" htmlFor='txnfltrcheck6'>DEBIT</label>
                            </div>
                        </li>
                    </ul>            

                    <PagiSearch setSearch={setSearch}
                    totalEntries={searchData.length}
                    setStartOffset={setStartOffset}
                    setTableDataStatus={setTableDataStatus} 
                    totalAmount={totalAmount} />

                    <div className="table-responsive my-2 com-table">
                    <table className="table table-bordered mb-1">
                        <thead>
                            <tr>
                            <th>#</th>
                                <th>User Id</th>
                                <th>Mid</th>
                                <th>Wallet Id</th>
                                <th>Order No</th>
                                <th>Beneficiary Account No</th>
                                <th>Beneficiary Address</th>
                                <th>Beneficiary Bank Name</th>
                                <th>Beneficiary Branch Address</th>
                                <th>Beneficiary City</th>
                                <th>Beneficiary Country</th>
                                <th>Beneficiary Email</th>
                                <th>Beneficiary Ifsc</th>
                                <th>Beneficiary Mobile</th>
                                <th>Beneficiary Name</th>
                                <th>Beneficiary Pincode</th>
                                <th>Beneficiary State</th>
                                <th>Transfer Amount</th>
                                <th>Previous Balance</th>
                                <th>Available Balance</th>
                                <th>Request Initiated Date</th>
                                <th>Paymode</th>
                                <th>Paymode Category</th>
                                <th>Me Trn Ref Id</th>
                                <th>Status</th>
                                <th>Status Code</th>
                                <th>RRN</th>
                                <th>Txn Type</th>
                                <th>Debit Amount</th>
                                <th>Credit Amount</th>
                                <th>Txn Ref No</th>
                                <th>Txn Date</th>
                                <th>Reversal Flag</th> 
                                <th>Reversal Status</th>
                                <th>Reversal Txn Id</th>

                                <th>Currency</th>
                                <th>Response Date</th>
                                <th>bank Callback Date</th>
                                <th>Me Callback Date</th>
                                <th>Me Response Url</th>
                                <th>Me Callback Url</th>
                                <th>Me Trn Ref Id</th>
                                <th>Charge Type</th>
                                 <th>Fee Type</th>

                                <th>Remark</th>
                            </tr>
                        </thead>
                        <tbody>
                            {currentItems.length < 1 ? <tr><td colSpan={11}><h6>{tableDataStatus}</h6></td></tr> : 
                            currentItems.map((item,index) => {
                                return (
                                <tr key={index}>
                                    <td>{startOffset + index + 1}</td>
                                    <td>{item.userId}</td>
                                    <td>{item.mid}</td>
                                    <td>{item.walletId}</td>
                                    <td>{item.orderNo}</td>
                                    <td>{item.beneAccountNo}</td>
                                    <td>{item.beneAddress}</td>
                                    <td>{item.beneBankName}</td>
                                    <td>{item.beneBranchAddress}</td>
                                    <td>{item.beneCity}</td>
                                    <td>{item.beneCountry}</td>
                                    <td>{item.beneEmail}</td>
                                    <td>{item.beneIfsc}</td>
                                    <td>{item.beneMobile}</td>
                                    <td>{item.beneName}</td>
                                    <td>{item.benePincode}</td>
                                    <td>{item.beneState}</td>
                                    <td>{item.transhferAmount/100}</td>
                                    <td>{item.previousBalance/100}</td>
                                    <td>{item.availableBalance/100}</td>
                                    <td>{item.requestInitiatedDateTime}</td>
                                    <td>{item.paymode}</td>
                                    <td>{item.paymodeCategory}</td>
                                    <td>{item.meTrnRefId}</td>
                                    <td>{item.status}</td>
                                    <td>{item.statusCode}</td>
                                    <td>{item.rrn}</td>
                                    <td className={item.txnType==='C'?'text-success  fw-bold text-center':'text-center text-danger fw-bold'} >{item.txnType==='C'?'Cr':'Dr'}</td>
                                    <td >{item.debitAmount/100}</td>
                                    <td>{item.creditAmount/100}</td>
                                    <td>{item.txnRefNo}</td>
                                    <td>{item.txnDateTime}</td>
                                    <td>{item.reversalFlag}</td>
                                    <td>{item.reversalStatus}</td>
                                    <td>{item.reversalTxnId}</td>
                                    <td>{item.currency}</td>
                                    <td>{item.respDateTime}</td>
                                    <td>{item.bankCallbackDateTime}</td>
                                    <td>{item.meCallbackDateTime}</td>
                                    <td>{item.meRespUrl}</td>
                                    <td>{item.meCallbackUrl}</td>
                                    <td>{item.meTrnRefId}</td>
                                    <td>{item.chargeType}</td>
                                    <td>{item.feeType === "F" ? "FLAT" : item.feeType === "P" ? "PERCENT" : ""}</td>

                                    <td>{item.remark}</td>         
                                </tr>
                                )
                            })}
                        </tbody>
                    </table>
                    </div>

                    <Pagination setStartOffset={setStartOffset}
                    pageCount={pageCount} itemsPerPage={itemsPerPage} />

                </div>
            </div>
        </section>
    </>)
}